"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIEW_HEIGHT = exports.MULTI_SECTION_CLOCK_SECTION_WIDTH = exports.MAX_CALENDAR_HEIGHT = exports.DIGITAL_CLOCK_VIEW_HEIGHT = exports.DIALOG_WIDTH = exports.DAY_SIZE = exports.DAY_MARGIN = void 0;
const DAY_SIZE = exports.DAY_SIZE = 36;
const DAY_MARGIN = exports.DAY_MARGIN = 2;
const DIALOG_WIDTH = exports.DIALOG_WIDTH = 320;
const MAX_CALENDAR_HEIGHT = exports.MAX_CALENDAR_HEIGHT = 280;
const VIEW_HEIGHT = exports.VIEW_HEIGHT = 336;
const DIGITAL_CLOCK_VIEW_HEIGHT = exports.DIGITAL_CLOCK_VIEW_HEIGHT = 232;
const MULTI_SECTION_CLOCK_SECTION_WIDTH = exports.MULTI_SECTION_CLOCK_SECTION_WIDTH = 48;